import * as types from "./actionTypes";

export const get = filter => {
  return {
    type: types.PROJECT_LIST_REQUEST,
    filter: filter
  };
};

export const getSuccess = data => {
  return {
    type: types.PROJECT_LIST_SUCCESS,
    payLoad: data
  };
};

export const getFailure = error => {
  return {
    type: types.PROJECT_LIST_FAILURE,
    error: error
  };
};

export const store = (data, isReload) => {
  return {
    type: types.PROJECT_STORE_REQUEST,
    data,
    isReload
  };
};
export const storeSuccess = data => {
  return {
    type: types.PROJECT_STORE_SUCCESS,
    payLoad: data
  };
};
export const storeFailure = () => {
  return {
    type: types.PROJECT_STORE_FAILURE
  };
};

export const deleteReq = id => {
  return {
    type: types.PROJECT_DELETE_REQUEST,
    id
  };
};
export const deleteSuccess = deletedProjectId => {
  return {
    type: types.PROJECT_DELETE_SUCCESS,
    deletedProjectId
  };
};
export const deleteFailure = () => {
  return {
    type: types.PROJECT_DELETE_FAILURE
  };
};

export const update = (data, id) => {
  return {
    type: types.PROJECT_UPDATE_REQUEST,
    data,
    id
  };
};
export const updateSuccess = data => {
  return {
    type: types.PROJECT_UPDATE_SUCCESS,
    payLoad: data
  };
};
export const updateFailure = () => {
  return {
    type: types.PROJECT_UPDATE_FAILURE
  };
};

export const accept = projectId => {
  return {
    type: types.PROJECT_ACCEPT_REQUEST,
    projectId
  };
};
export const acceptSuccess = data => {
  return {
    type: types.PROJECT_ACCEPT_SUCCESS,
    data: data
  };
};
export const acceptFailure = () => {
  return {
    type: types.PROJECT_ACCEPT_FAILURE
  };
};

export const reject = projectId => {
  return {
    type: types.PROJECT_REJECT_REQUEST,
    projectId
  };
};
export const rejectSuccess = data => {
  return {
    type: types.PROJECT_REJECT_SUCCESS,
    data: data
  };
};
export const rejectFailure = () => {
  return {
    type: types.PROJECT_REJECT_FAILURE
  };
};

export const archive = (id, data) => {
  return {
    type: types.PROJECT_ARCHIVE_REQUEST,
    id,
    data
  };
};
export const archiveSuccess = (id, data) => {
  return {
    type: types.PROJECT_ARCHIVE_SUCCESS,
    id,
    data
  };
};
export const archiveFailure = () => {
  return {
    type: types.PROJECT_ARCHIVE_FAILURE
  };
};

export const answerInvitation = (projectId, ansIsAccept) => {
  return {
    type: types.PROJECT_ANSWER_INVITATION_REQUEST,
    projectId,
    ansIsAccept
  };
};
export const answerInvitationSuccess = (projectId, ansIsAccept, data) => {
  return {
    type: types.PROJECT_ANSWER_INVITATION_SUCCESS,
    projectId,
    ansIsAccept,
    data
  };
};
export const answerInvitationFailure = () => {
  return {
    type: types.PROJECT_ANSWER_INVITATION_FAILURE
  };
};

export const getUsersListRequest = () => {
  return {
    type: types.PROJECT_USERS_LIST_REQUEST
  };
};
export const getUsersListSuccess = data => {
  return {
    type: types.PROJECT_USERS_LIST_SUCCESS,
    payLoad: data
  };
};
export const getUsersListFailure = error => {
  return {
    type: types.PROJECT_USERS_LIST_FAILURE,
    error: error
  };
};

export const getTypes = () => {
  return {
    type: types.PROJECT_TYPES_REQUEST
  };
};

export const getTypesSuccess = data => {
  return {
    type: types.PROJECT_TYPES_SUCCESS,
    payLoad: data
  };
};

export const getTypesFailure = error => {
  return {
    type: types.PROJECT_TYPES_FAILURE,
    error: error
  };
};

export const clearList = () => {
  return {
    type: types.PROJECT_CLEAR_LIST
  };
};

export const reInitializedPendingList = data => {
  return {
    type: types.PROJECT_REINITIALIZED_PENDING_LIST,
    data
  };
};

export const setConfirmInfo = info => {
  return {
    type: types.SET_PROJECT_DELETE_ARCHIVE_CONFIRM_INFO,
    info: info
  };
};

export const showUsernameModal = () => {
  return {
    type: types.SHOW_USERNAME_MODAL
  };
};
